import { useFeatureFlag } from 'configcat-react';
import { FEATURE_FLAG } from '@dealstack/shared/lib/common/featureFlag.ts';
import { User as ConfigCatUser } from 'configcat-common/lib/RolloutEvaluator';
import { useAppSelector } from '@dealstack/frontend/app/hooks/redux.ts';

/**
 * Hook to get the feature flag value for a given feature flag
 *
 * @param FEATURE_FLAG - From the featureFlag.ts file key- value pair
 * @returns boolean - The value of the feature flag
 */
const useDealstackFeatureFlag = (
	featureFlag: FEATURE_FLAG,
	customUserAttributes: Record<string, string> = {}
) => {
	const userState = useAppSelector((state) => state.user);
	const userObject = new ConfigCatUser(
		userState.data?.id ?? '',
		userState.data?.email ?? '',
		'',
		customUserAttributes
	);

	const { value, loading } = useFeatureFlag(featureFlag, false, userObject);

	return { value, loading };
};

export { useDealstackFeatureFlag };
